export class TableLinkColumnDTO {
  linkColor: 'primary' | 'accent' | 'warn'
  linkText: string
  linkUrl: string
  linkData: string
  selected: boolean
  // Accessible name for per-row buttons whose visible text alone ("Retry") is ambiguous.
  ariaLabel?: string
}
